import React, { Component } from 'react'
import Web3 from 'web3'
import './css.css';



class Box1_0 extends Component {
constructor(props){
    super()
    this.showBox=this.showBox.bind(this)
}

showBox(){
    this.props.showBox(this.props.address,this.props.index)
}

    render(props){
    let addr="https://ropsten.etherscan.io/address/"+this.props.address
        return (
        <div>
            <div className="Box_Modules dark darkblue text white" onClick={this.showBox}>                        
                <span className="Shop_module_icon"><a className="box_link" target="_blank" href={addr}>📦</a> </span>#{this.props.index} HappyBox 1.0
              
                <div className="Box_desc text white">shop basic storage</div>
           
            </div>
        </div>         
        );
    }


}

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}



        
const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")




export default Box1_0